import { agencyLogo, agencyLogoAssets } from './agencyBrand'
import cgvVacation from '../assets/img/img/cgv-vacation.png'
import { quotationServiceError } from './quotationServiceFamily'
// Trame reprise du dashboard admin : components/Client/quotationPdf.js
import jsPDF from 'jspdf'
import cgpDelegationAsnieres from '../assets/adminQuotation/CGP-delegation-jminterim_page-0001.jpg'
import cgpDelegationBrive from '../assets/adminQuotation/CGP-delegation-brive_page-0001.jpg'
import cgpDelegationToulouse from '../assets/adminQuotation/CGP-delegation-toulouse_page-0001.jpg'
import cgpPlacementAsnieres from '../assets/adminQuotation/CGP-placement-jminterim_page-0001.jpg'
import cgpPlacementBrive from '../assets/adminQuotation/CGP-placement-brive_page-0001.jpg'
import cgpPlacementToulouse from '../assets/adminQuotation/CGP-placement-toulouse_page-0001.jpg'
import propositionJminterim from '../assets/adminQuotation/proposition-jminterim.jpg'
import propositionCapeneo from '../assets/adminQuotation/proposition-capaneo.jpg'
import myImage from '../assets/adminQuotation/JM_INTERIM_LEGER.jpg'
import logotoulouse from '../assets/adminQuotation/logotoulouse.png'
import logobrive from '../assets/adminQuotation/logobrive.png'
import gmail from '../assets/adminQuotation/gmail.png'
import phone from '../assets/adminQuotation/phone.png'

// Découpe une chaîne en morceaux de taille maximale sans couper les mots.
function splitStringWithoutCuttingWords(inputString, chunkSize) {
  const words = inputString.split(' ')
  const resultChunks = []
  let currentChunk = ''

  for (const word of words) {
    if (currentChunk.length + word.length <= chunkSize) {
      currentChunk += (currentChunk ? ' ' : '') + word
    } else {
      resultChunks.push(currentChunk)
      currentChunk = word
    }
  }

  if (currentChunk) {
    resultChunks.push(currentChunk)
  }

  return resultChunks
}

const formatJsDate = (date) => {
  const newDate = new Date(date)
  const day = String(newDate.getDate()).padStart(2, '0')
  const month = String(newDate.getMonth() + 1).padStart(2, '0')
  const year = newDate.getFullYear()

  return `${day}/${month}/${year}`
}

const formatJsDate2 = (date) => {
  const newDate = new Date(date)
  const month = String(newDate.getMonth() + 1).padStart(2, '0')
  const year = newDate.getFullYear()

  return `${month}${year}`
}

// Génère le PDF d'un devis. Avec { asBase64: true }, renvoie la chaîne base64
// (sans le préfixe data:), sinon ouvre le PDF dans un nouvel onglet.
export const generateQuotationPdf = (quotation, options = {}) => {
  const familyError = quotationServiceError(quotation.products);
  if (familyError) throw new Error(familyError);

  // Valeurs par défaut pour l'agence si non renseignée
  const defaultAgency = {
    name: "J'M INTERIM",
    address: '4 Avenue Laurent Cély, Hall A',
    postCode: '92600',
    town: 'Asnières sur Seine',
    siret: '91912551800010',
    tva: 'FR52919125518',
    email: 'contact@jm-interim.com',
    phone: '01 80 88 21 35',
  }
  const agency = quotation.agency || defaultAgency

  const pdf = new jsPDF({
    unit: 'mm',
    format: [210, 297],
    compress: true,
  })

  // Les fonds pleine page sont des JPEG : les déclarer en 'JPEG' évite un
  // ré-encodage PNG sans perte qui alourdissait fortement le fichier.
  if (agency.name === 'JM Capeneo Santé')
    pdf.addImage(propositionCapeneo, 'JPEG', 0, 0, 210, 297)
  else if (agency.name === 'JM CAPENEO')
    pdf.addImage(propositionCapeneo, 'JPEG', 0, 0, 210, 297)
  else pdf.addImage(propositionJminterim, 'JPEG', 0, 0, 210, 297)

  pdf.addPage()

  pdf.addImage(agencyLogo(agency), 'JPEG', 14, 10, 40, 26.67)

  const gmailImg = new Image()
  gmailImg.src = gmail

  const phoneImg = new Image()
  phoneImg.src = phone

  pdf.setFontSize(14)
  pdf.setFont('Helvetica', 'Bold')
  pdf.text(agency.name, 24, 45)
  pdf.setFontSize(9)
  pdf.setFont('Helvetica', 'normal')
  pdf.text(agency.address, 15, 50)
  pdf.text(agency.postCode + ' ' + agency.town, 15, 55)
  pdf.text('SIRET  : ' + agency.siret, 15, 60)
  pdf.text('TVA n° : ' + agency.tva, 15, 65)
  pdf.addImage(gmailImg, 'PNG', 15, 67, 3, 3)

  pdf.text(' : ' + agency.email, 18, 69.5)
  pdf.addImage(phoneImg, 'PNG', 15, 71.5, 3, 3)
  pdf.text(' : ' + agency.phone, 18, 74)
  const contactName =
    'Contact : ' +
    (quotation.creator?.firstname?.charAt(0).toUpperCase() || '') +
    (quotation.creator?.firstname?.slice(1) || '') +
    ' ' +
    (quotation.creator?.lastname?.charAt(0).toUpperCase() || '') +
    (quotation.creator?.lastname?.slice(1) || '')
  pdf.text(contactName, 15, 79.5)

  pdf.setFontSize(14)
  pdf.setFont('Helvetica', 'Bold')
  let quotationNumber =
    'Devis n° ' +
    formatJsDate2(quotation.createdAt) +
    '-' +
    quotation.quotationNumber?.toString().padStart(5, 0)
  if (quotation.isDraft) quotationNumber = 'Devis provisoire'
  pdf.text(quotationNumber, 110, 45)

  pdf.setFontSize(9)
  pdf.setFont('Helvetica', 'normal')

  pdf.text('Date : ', 110, 50)
  pdf.text(formatJsDate(quotation.createdAt), 120, 50)

  pdf.text("Date d'expiration :", 110, 55)
  pdf.text(formatJsDate(quotation.expiryDate), 137, 55)

  pdf.setFontSize(10)
  pdf.setFont('Helvetica', 'Bold')
  pdf.text('Adresse de facturation :', 15, 95)

  pdf.setFontSize(9)
  pdf.setFont('Helvetica', 'normal')
  const addressFacturation = (quotation.addressFacturation ?? '').toString().trim()
  const addressMatch = addressFacturation.match(/^(.*?)\b(\d{5})\b(.*)$/)
  var [partieAvant, codePostal, partieApres] = addressMatch
    ? addressMatch.slice(1).map((str) => str.trim())
    : [addressFacturation, '', '']
  try {
    pdf.text(partieAvant, 15, 100)
    pdf.text(codePostal + ' ' + partieApres, 15, 105)
  } catch (e) {
    console.log(e)
  }

  pdf.setFontSize(12)
  pdf.setFont('Helvetica', 'Bold')

  const companyNameArray = splitStringWithoutCuttingWords(
    quotation.client.companyName.toUpperCase(),
    30,
  )
  let size = 80 - (companyNameArray.length - 1) * 5
  for (let name of companyNameArray) {
    pdf.text(name, 110, size)
    size += 5
  }

  pdf.setFontSize(9)
  pdf.setFont('Helvetica', 'normal')
  // On ne garde que le nom et le prénom : on retire l'email (contient @)
  // et le téléphone (tokens contenant un chiffre).
  const contact = (quotation.contact ?? '')
    .toString()
    .split(' ')
    .filter((part) => part && !part.includes('@') && !/\d/.test(part))
    .join(' ')
    .trim()

  pdf.text(`${contact.toUpperCase()}`, 110.5, 85)
  pdf.text(partieAvant, 110.5, 90)
  pdf.text(codePostal + ' ' + partieApres, 110.5, 95)
  pdf.text('SIRET : ' + quotation.client.siret, 110.5, 100)
  pdf.text('TVA : ' + quotation.client.TVA, 110.5, 105)

  pdf.setFontSize(12)
  pdf.setFont('Helvetica', 'bold')
  pdf.setTextColor(9, 132, 227)
  pdf.setDrawColor(9, 132, 227)

  if (
    quotation.products[0].product === 'Placement' ||
    quotation.products[0].product === 'Vacation'
  ) {
    pdf.roundedRect(26, 115, 160, 30, 1, 1)
    pdf.text(quotation.products[0].product.toUpperCase(), 95, 120)
    pdf.line(95, 122, 122, 122)

    pdf.setFontSize(9)
    pdf.setFont('Helvetica', 'normal')
    pdf.setTextColor(0, 0, 0)

    pdf.text(
      'Vous nous mandatez pour recruter au sein de votre entreprise, un poste en CDD ou CDI.',
      46,
      130,
    )
    pdf.text(
      "Le contrat, la DPAE et la fiche de paie sont établis par vos soins. Vous êtes l'employeur.",
      46,
      135,
    )
    pdf.text('Vous recevrez une seule facture pour le placement', 57, 140)
  }

  if (
    quotation.products[0].product === 'Délégation' ||
    quotation.products[0].product === 'Gestion'
  ) {
    pdf.roundedRect(15, 110, 92, 35, 1, 1)
    pdf.roundedRect(110, 110, 92, 35, 1, 1)
    pdf.text('DELEGATION', 47, 115)
    pdf.line(47, 117, 75, 117)
    pdf.text('GESTION', 145, 115)
    pdf.line(145, 117, 164, 117)

    pdf.setFontSize(9)
    pdf.setFont('Helvetica', 'normal')
    pdf.setTextColor(0, 0, 0)

    pdf.text('Vous nous mandatez pour', 17, 125)
    pdf.setFont('Helvetica', 'bold')
    pdf.text('recruter', 55, 125)
    pdf.setFont('Helvetica', 'normal')
    pdf.text('   et', 65, 125)
    pdf.setFont('Helvetica', 'bold')
    pdf.text('  gérer', 70, 125)
    pdf.setFont('Helvetica', 'normal')
    pdf.text(" l'administratif", 80, 125)
    pdf.text('de ', 17, 130)
    pdf.setFont('Helvetica', 'bold')
    pdf.text('notre', 21, 130)
    pdf.setFont('Helvetica', 'normal')
    pdf.text('recrue. Le contrat, la DPAE et la fiche de paie sont', 30, 130)
    pdf.text(
      "établis par nous, qui sommes l'employeur. Vous avez à charge",
      17,
      135,
    )
    pdf.text(
      'la sécurité du salarié. Vous recevrez une facture mensuelle.',
      17,
      140,
    )

    pdf.text('Vous nous mandatez pour', 112, 125)
    pdf.setFont('Helvetica', 'bold')
    pdf.text('gérer', 150, 125)
    pdf.setFont('Helvetica', 'normal')
    pdf.text("simplement l'administratif", 159, 125)
    pdf.text('de', 112, 130)
    pdf.setFont('Helvetica', 'bold')
    pdf.text('votre', 116, 130)
    pdf.setFont('Helvetica', 'normal')
    pdf.text('recrue. Le contrat, la DPAE et la fiche de paie sont', 125, 130)
    pdf.text(
      "établis par nous, qui sommes l'employeur. Vous avez à charge",
      112,
      135,
    )
    pdf.text(
      'la sécurité du salarié. Vous recevrez une facture mensuelle.',
      112,
      140,
    )
  }

  pdf.setTextColor(0, 0, 0)

  pdf.setFillColor(9, 132, 227)
  pdf.setDrawColor(9, 132, 227)
  pdf.rect(15, 155, 180, 10, 'F')

  pdf.setTextColor(255, 255, 255)
  pdf.setFontSize(10)
  pdf.setFont('Helvetica', 'bold')

  if (
    quotation.products[0].product === 'Délégation' ||
    quotation.products[0].product === 'Gestion'
  ) {
    let height = 170

    pdf.text('Designation', 25, 161)
    pdf.text('Taux horaire', 60, 161)
    pdf.text('Coefficient', 95, 161)
    pdf.text('Prix HT/heure', 130, 159)
    pdf.text('travaillée', 135, 163)
    pdf.text('Observation', 165, 161)

    pdf.setFontSize(10)
    pdf.setFont('Helvetica', 'normal')
    pdf.setTextColor(0, 0, 0)
    pdf.setDrawColor(0, 0, 0)

    quotation.products.map((product, idx) => {
      const primeTypes = [
        'Prime',
        'Indemnité',
        'Prime Ségur',
        'Primes diverses',
      ]
      if (primeTypes.includes(product.type)) {
        const prime = splitStringWithoutCuttingWords(
          product.type + ' : ' + product.product,
          24,
        )
        for (let i = 0; i < prime.length; i++) {
          pdf.text(prime[i], 20, height)
          height += 5
        }
        height -= 5
      } else if (product.type === 'Autre')
        pdf.text(product.product, 20, height)
      else {
        pdf.text(product.product + ' H/F', 20, height)
        const poste = splitStringWithoutCuttingWords(product.poste, 24)
        for (let i = 0; i < poste.length; i++) {
          pdf.text(poste[i], 20, height + 5)
          height += 5
        }
      }
      const hasTaux = product.taux !== '' && product.taux != null
      const hasCoeff =
        product.coefficient !== '' && product.coefficient != null

      if (!hasTaux && !hasCoeff) {
        // Aucun taux ni coefficient : le commentaire est centré sur la ligne.
        const comment = splitStringWithoutCuttingWords(
          product.comment || '',
          80,
        )
        for (let i = 0; i < comment.length; i++) {
          pdf.text(comment[i], 105, height, { align: 'center' })
          height += 5
        }
      } else {
        if (hasTaux)
          pdf.text(parseFloat(product.taux).toFixed(2) + '€', 65, height)
        if (hasCoeff) pdf.text(String(product.coefficient), 105, height)
        if (hasTaux && hasCoeff)
          pdf.text(
            (
              parseFloat(product.taux) * parseFloat(product.coefficient)
            ).toFixed(2) + '€',
            140,
            height,
          )
        const comment = splitStringWithoutCuttingWords(
          product.comment || '',
          24,
        )
        for (let i = 0; i < comment.length; i++) {
          pdf.text(comment[i], 165, height)
          height += 5
        }
      }
      height += 5
      pdf.setTextColor(128, 128, 128)
      pdf.setDrawColor(128, 128, 128)
      if (product.minimumHours) {
        pdf.text(
          "Nombre d'heures minimales avant embauche sans facturation : " +
            product.minimumHours +
            'h',
          50,
          height,
        )
        height += 3
      }

      if (idx === quotation.products.length - 1) {
        pdf.setDrawColor(0, 0, 0)
        pdf.setLineWidth(0.5)
      }
      pdf.line(15, height, 195, height)
      pdf.setTextColor(0, 0, 0)
      pdf.setDrawColor(0, 0, 0)
      height += 7
      if (height > 260) {
        pdf.addPage()
        height = 10
      }
    })

    height += 10
    if (height > 250) {
      pdf.addPage()
      height = 10
    }

    pdf.setFontSize(9)
    pdf.setFont('Helvetica', 'normal')

    pdf.text('Nom et qualité du signataire :', 15, height)
    pdf.text('Date : ' + formatJsDate(new Date()), 15, height + 5)

    pdf.text(String(quotation.client.tvaRate ?? ''), 120, height)
    pdf.text(
      'Conditions de paiement : ' + quotation.client.facturation,
      120,
      height + 5,
    )
    pdf.text('Moyen de règlement : Virement/Chèque/Prélèvement', 120, height + 10)
  }

  if (
    quotation.products[0].product === 'Placement' ||
    quotation.products[0].product === 'Vacation'
  ) {
    let height = 170

    pdf.text('Designation', 25, 161)
    pdf.text('Quantité', 68, 161)
    pdf.text('PU (HT)', 110, 161)
    pdf.text('Montant (HT)', 160, 161)

    pdf.setFontSize(10)
    pdf.setFont('Helvetica', 'normal')
    pdf.setTextColor(0, 0, 0)
    pdf.setDrawColor(0, 0, 0)

    quotation.products.map((product, idx) => {
      pdf.text(product.product + ' H/F', 20, height)
      pdf.text(product.poste, 20, height + 5)
      height += 5
      if (product.taux !== '')
        pdf.text(parseFloat(product.taux).toFixed(2) + '€', 110, height)
      if (product.coefficient !== '')
        pdf.text(String(product.coefficient), 75, height)
      if (product.taux !== '' && product.coefficient !== '')
        pdf.text(
          (
            parseFloat(product.taux) * parseFloat(product.coefficient)
          ).toFixed(2) + '€',
          175,
          height,
        )
      height += 5
      pdf.setTextColor(128, 128, 128)
      pdf.setDrawColor(128, 128, 128)

      if (idx === quotation.products.length - 1) {
        pdf.setDrawColor(0, 0, 0)
        pdf.setLineWidth(0.5)
      }
      pdf.line(15, height, 195, height)
      pdf.setTextColor(0, 0, 0)
      pdf.setDrawColor(0, 0, 0)
      height += 7
      if (height > 260) {
        pdf.addPage()
        height = 10
      }
    })

    if (height > 250) {
      pdf.addPage()
      height = 10
    }

    pdf.setFillColor(135, 177, 255)
    pdf.setDrawColor(9, 132, 227)
    height += 6
    pdf.setTextColor(255, 255, 255)
    pdf.setFont('Helvetica', 'Bold')

    pdf.setTextColor(0, 0, 0)
    pdf.setFont('Helvetica', 'normal')

    pdf.text('Total HT', 110, height)
    pdf.text(
      quotation.products
        .reduce(
          (total, item) =>
            total +
            (parseFloat(item.taux) || 0) * (parseFloat(item.coefficient) || 0),
          0,
        )
        .toFixed(2) + ' €',
      174,
      height,
    )

    height += 10

    pdf.text(
      (
        quotation.products.reduce(
          (total, item) =>
            total +
            (parseFloat(item.taux) || 0) * (parseFloat(item.coefficient) || 0),
          0,
        ) * 0.2
      ).toFixed(2) + ' €',
      174,
      height,
    )
    height += 10
    pdf.setFillColor(9, 132, 227)
    pdf.rect(105, height - 7, 90, 10, 'F')
    pdf.setTextColor(255, 255, 255)
    pdf.text('Total TTC', 110, height)
    pdf.text(
      (
        parseFloat(
          quotation.products.reduce(
            (total, item) =>
              total +
              (parseFloat(item.taux) || 0) * (parseFloat(item.coefficient) || 0),
            0,
          ) * 0.2,
        ) +
        parseFloat(
          quotation.products.reduce(
            (total, item) =>
              total +
              (parseFloat(item.taux) || 0) * (parseFloat(item.coefficient) || 0),
            0,
          ),
        )
      ).toFixed(2) + ' €',
      174,
      height,
    )

    pdf.setTextColor(0, 0, 0)

    height += 10

    if (height >= 270) pdf.addPage()

    pdf.setFontSize(9)
    pdf.setFont('Helvetica', 'normal')

    if (height > 280) {
      pdf.addPage()
      height = 10
    }

    const paymentCondition = splitStringWithoutCuttingWords(
      'Conditions de paiement : ' +
        (quotation.products[0]?.comment ?? '').toString().replace(/\n/g, ''),
      70,
    )

    pdf.text('Nom et qualité du signataire :', 15, height)
    pdf.text('Date : ' + formatJsDate(new Date()), 15, height + 5)

    pdf.text('Moyen de règlement : Virement/Chèque/Prélèvement', 90, height)
    for (let x of paymentCondition) {
      pdf.text(x, 90, height + 5)
      height += 4
      if (height >= 280) {
        pdf.addPage()
        height = 10
      }
    }
    if (quotation.products[0].product === 'Placement') {
      const replaceCondition = splitStringWithoutCuttingWords(
        'Conditions de remplacement : ' +
          (quotation.products[0]?.comment2 ?? '').toString().replace(/\n/g, ''),
        70,
      )
      for (let x of replaceCondition) {
        pdf.text(x, 90, height + 10)
        height += 4
        if (height >= 280) {
          pdf.addPage()
          height = 10
        }
      }
    }
  }

  pdf.text(
    `J'm intérim - SAS au capital de 230 000 € - 4 Avenue Laurent Cély, Hall A, 92600 Asnières sur Seine, France`,
    25,
    280,
  )
  pdf.text(
    'SIRET : 91912551800010 - Code APE : 7820z - N° de TVA : FR52919125518',
    50,
    285,
  )

  appendQuotationConditions(pdf, quotation)

  if (options.asBase64) {
    return pdf.output('datauristring').split(',')[1]
  }

  const pdfBlob = pdf.output('blob')
  const pdfUrl = URL.createObjectURL(pdfBlob)
  if (options.asUrl) return pdfUrl
  if (options.download) {
    const link = document.createElement('a')
    link.href = pdfUrl
    link.download = `Devis_${quotation.quotationNumber || 'Provisoire'}.pdf`
    link.click()
    setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000)
  } else window.open(pdfUrl, '_blank')
}

export default generateQuotationPdf

export const quotationPdfAssets = [...agencyLogoAssets, cgvVacation, cgpDelegationAsnieres, cgpDelegationBrive, cgpDelegationToulouse, cgpPlacementAsnieres, cgpPlacementBrive, cgpPlacementToulouse, propositionJminterim, propositionCapeneo, myImage, logotoulouse, logobrive, gmail, phone];

export function appendQuotationConditions(pdf, quotation) {
  pdf.addPage()
  // Déterminer si c'est Délégation/Gestion ou Placement/Vacation
  const isDelegationOrGestion =
    quotation.products.some(row => ['Délégation', 'Gestion'].includes(row.product || row.type))

  if (quotation.products.some(row => (row.product || row.type) === 'Vacation')) {
    pdf.addImage(cgvVacation, 'PNG', 10, 10, 198, 282)
  } else if (quotation.agency.name === 'JM Capeneo Santé') {
    // Toulouse
    pdf.addImage(
      isDelegationOrGestion ? cgpDelegationToulouse : cgpPlacementToulouse,
      'JPEG',
      10,
      10,
      198,
      282,
    )
  } else if (quotation.agency.name === 'JM CAPENEO') {
    // Brive
    pdf.addImage(
      isDelegationOrGestion ? cgpDelegationBrive : cgpPlacementBrive,
      'JPEG',
      10,
      10,
      198,
      282,
    )
  } else {
    // Asnières (J'M INTERIM ou autre)
    pdf.addImage(
      isDelegationOrGestion ? cgpDelegationAsnieres : cgpPlacementAsnieres,
      'JPEG',
      10,
      10,
      198,
      282,
    )
  }

}
